import { render, staticRenderFns } from "./turn.vue?vue&type=template&id=6f80f777&scoped=true"
import script from "./turn.vue?vue&type=script&lang=js"
export * from "./turn.vue?vue&type=script&lang=js"
import style0 from "./turn.vue?vue&type=style&index=0&id=6f80f777&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f80f777",
  null
  
)

export default component.exports